import { api } from "../helpers";

export const getMasterEnum = (): any =>
	api("/enumData", "GET",null);
